import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress, _UBLPaymentMeans } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { UBLPaymentMeansCodeEditor } from "../UBLPaymentMeansCode/UBLPaymentMeansCodeEditor";
import { PaymentTypeConst } from "../../../erp/cellEditor/PaymentType/PaymentTypeConst";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


export const UBLPaymentMeans = () => {

    const ublpay = useDataBean(_UBLPaymentMeans);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [regexStr, setregexStr] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        ublpay.instance.getUBLPaymentMeansCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)

                }
            }
        )

    }
    const create = () => {
        ublpay.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ublpay.instance.deleteUBLPaymentMeans(ublpay.bean.IDUBLPaymentMeans).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        ublpay.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDUBLPaymentMeans', visible: true },
        { title: 'Código', property: 'PaymentMeansID', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Habiltado', property: 'IsEnabled', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Formas de Pago">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ublpay.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <PaymentTypeConst idSelector={ublpay.bean.Type} onChange={(e) => { ublpay.setBean({ ...ublpay.bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" name="PaymentMeansID" className="form-control" value={ublpay.bean.PaymentMeansID} onChange={(e) => { ublpay.setBean({ ...ublpay.bean, "PaymentMeansID": e.target.value }) }} />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitado" estado={ublpay.bean.IsEnabled} eventChange={(e: any) => { ublpay.setBean({ ...ublpay.bean, "IsEnabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={ublpay.bean.Description} onChange={ublpay.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ublpay.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}